import { useSelector } from 'react-redux'
import { RootState } from '../../store/configure-store'
import { SelectCompanyPrompt } from '../../cmps/general/select-company-prompt'
import { AuditTrailFeed } from '../../cmps/audit-trails/audit-trail-feed'

export const AuditTrailsPage: React.FC = () => {
  const companyName = useSelector((state: RootState) => state.companyName.value)

  if (!companyName) {
    return <div className="tablePageContainer">
      <SelectCompanyPrompt />
    </div>
  }

  return <div className="tablePageContainer">
    <div className="page-header">
      <p className="tableSubtitle">Audit history for the selected company.</p>
    </div>
    <AuditTrailFeed companyName={companyName} hideCompanyFilter={true} auditScope="tenant" />
  </div>
}
